import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ResearchAuthGuard } from "research.oidc.angular";
import { RequestHeaderComponent } from "./request-header/request-header.component";
import { RequestOptionsResolver } from "../shared/resolvers/request-options-resolver";
import { RequestDetailsResolver } from "../shared/resolvers/request-details.resolver";
import { RequestDesignResolver } from "../shared/resolvers/request-design.resolver";
import { ExperimentDetailsFormPageComponent } from "./experiment-details/experiment-details-form-page/experiment-details-form-page.component";
import { ExperimentDesignFormPageComponent } from "./experiment-design/experiment-design-form-page/experiment-design-form-page.component";
import { UserRoleGuard } from "./user-role-guard";
import { UserRoles } from "../shared/services/current-user.service";
import { CurrentUserResolver } from "../shared/resolvers/current-user.resolver";
import { SeedRequestsResolver } from "../shared/resolvers/seed-requests-resolver";

const routes: Routes = [
  {
    path: "requests/create",
    component: RequestHeaderComponent,
    canActivate: [ResearchAuthGuard, UserRoleGuard],
    data: {
      allowedRoles:  UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator,
      message: 'You are not authorized to create requests'
    },
    resolve: {
      requestOptions: RequestOptionsResolver,
      currentUser: CurrentUserResolver
    }
  },
  {
    path: 'requests/edit/:id/details',
    component: ExperimentDetailsFormPageComponent,
    canActivate: [ResearchAuthGuard, UserRoleGuard],
    data: {
      allowedRoles:  UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator,
      message: 'You are not authorized to edit requests'
    },
    resolve: {
      requestOptions: RequestOptionsResolver,
      requestDetails: RequestDetailsResolver,
      requestDesign: RequestDesignResolver,
      currentUser: CurrentUserResolver
    }
  },
  {
    path: 'requests/edit/:id/design',
    component: ExperimentDesignFormPageComponent,
    canActivate: [ResearchAuthGuard, UserRoleGuard],
    data: {
      allowedRoles:  UserRoles.Requestor | UserRoles.CollaboratorLiaison | UserRoles.TacticalLiaison | UserRoles.ExperimentCreator,
      message: 'You are not authorized to edit requests'
    },
    resolve: {
      requestOptions: RequestOptionsResolver,
      requestDetails: RequestDetailsResolver,
      requestDesign: RequestDesignResolver,
      seedRequests: SeedRequestsResolver
    }
  },
  {
    path: 'requests/edit/:id',
    redirectTo: 'requests/edit/:id/details'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequestCreationRoutingModule {}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/request-creation-routing.module.ts